import sgccApi from "@/api/sgccApi"

export const obtainAllTeachers = async ( { commit } ) => {
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.get(`/api/docentes`)
        if (data.ok) {
            commit('setTeachers', data.docentes)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error }
    }
}

export const editTeacher = async ( _, { form } ) => {
    const teachersForm = {
        nombre: form.nombre,
        user: form.user,
        email: form.email,
        campus_id: form.campus_id,
        nivel_academico_id: form.nivel_academico_id,
    }
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.put(`/api/docentes/${form.id}`, teachersForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error?.response?.data?.message }
    }
}

export const createTeacher = async ( _, { form } ) => {
    const teachersForm = {
        nombre: form.nombre,
        user: form.user,
        email: form.email,
        campus_id: form.campus_id,
        nivel_academico_id: form.nivel_academico_id,
    }
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.post(`/api/docentes`, teachersForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error?.response?.data?.message }
    }
}

export const deleteTeacher = async ( _, id ) => {
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.delete(`/api/docentes/${id}`)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}